export default __webpack_public_path__ + "static/media/imgpost13.660f4870.jpg";